module.exports = __webpack_public_path__ + "static/0074-5020a208933eedcdf0e310b428909528.png";